function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 35,
  width: 488,
  height: 430,
  fill: "#F5FDFF"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_d_131_90)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 419,
  y: 195,
  width: 131,
  height: 254.855,
  rx: 14.8864,
  fill: "#808080"
}), /*#__PURE__*/React.createElement("rect", {
  x: 424.955,
  y: 200.359,
  width: 119.091,
  height: 244.136,
  rx: 12.5045,
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M424.955 212.864C424.955 205.958 430.553 200.359 437.459 200.359H531.541C538.447 200.359 544.046 205.958 544.046 212.864V225.964H424.955V212.864Z",
  fill: "#2896C9"
}), /*#__PURE__*/React.createElement("rect", {
  x: 432.696,
  y: 209.887,
  width: 7.74091,
  height: 1.19091,
  fill: "white"
}), /*#__PURE__*/React.createElement("rect", {
  x: 432.696,
  y: 212.864,
  width: 7.74091,
  height: 1.19091,
  fill: "white"
}), /*#__PURE__*/React.createElement("rect", {
  x: 432.696,
  y: 215.841,
  width: 7.74091,
  height: 1.19091,
  fill: "white"
}), /*#__PURE__*/React.createElement("rect", {
  x: 424.955,
  y: 225.964,
  width: 119.091,
  height: 119.091,
  fill: "#333333"
}), /*#__PURE__*/React.createElement("path", {
  d: "M484.5 259.905L488.607 266.92L495.351 262.381L496.008 270.484L504.053 269.321L501.129 276.906L508.882 279.349L502.957 284.914L508.882 290.479L501.129 292.922L504.053 300.507L496.008 299.344L495.351 307.446L488.607 302.908L484.5 309.923L480.393 302.908L473.649 307.446L472.992 299.344L464.947 300.507L467.871 292.922L460.118 290.479L466.043 284.914L460.118 279.349L467.871 276.906L464.947 269.321L472.992 270.484L473.649 262.381L480.393 266.92L484.5 259.905Z",
  fill: "#2896C9"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M495.538 279.797L492.467 276.727L482.027 287.167L477.114 282.254L474.043 285.325L478.956 290.238L478.956 290.238L482.026 293.309L482.027 293.308L482.027 293.309L485.098 290.238L485.097 290.238L495.538 279.797Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("rect", {
  x: 440.437,
  y: 373.041,
  width: 86.9364,
  height: 3.57273,
  fill: "#CCCCCC"
}), /*#__PURE__*/React.createElement("rect", {
  x: 440.437,
  y: 358.155,
  width: 66.6909,
  height: 7.74091,
  fill: "#333333"
}), /*#__PURE__*/React.createElement("rect", {
  x: 440.437,
  y: 388.523,
  width: 86.9364,
  height: 3.57273,
  fill: "#CCCCCC"
}), /*#__PURE__*/React.createElement("rect", {
  x: 440.437,
  y: 380.782,
  width: 75.6227,
  height: 3.57273,
  fill: "#CCCCCC"
}), /*#__PURE__*/React.createElement("rect", {
  x: 440.437,
  y: 396.264,
  width: 75.6227,
  height: 3.57273,
  fill: "#CCCCCC"
}));

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M366.503 336.497C353.375 323.37 346 305.565 346 287C346 268.435 353.375 250.63 366.503 237.503L416 287L366.503 336.497Z",
  fill: "#D9D9D9"
});

var _ref5 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0_131_90)"
}, /*#__PURE__*/React.createElement("circle", {
  r: 54.625,
  transform: "matrix(-1 0 0 1 416.625 288.875)",
  stroke: "#808080",
  strokeWidth: 7
}), /*#__PURE__*/React.createElement("circle", {
  r: 38.375,
  transform: "matrix(-1 0 0 1 416.625 288.875)",
  stroke: "#808080",
  strokeWidth: 7
}), /*#__PURE__*/React.createElement("circle", {
  r: 20.875,
  transform: "matrix(-1 0 0 1 416.625 288.875)",
  stroke: "#808080",
  strokeWidth: 7
}));

var _ref6 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter1_d_131_90)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 10,
  y: 22,
  width: 334,
  height: 314,
  fill: "#333333"
}));

var _ref7 = /*#__PURE__*/React.createElement("rect", {
  x: 35,
  y: 46,
  width: 284,
  height: 265,
  fill: "#CCCCCC"
});

var _ref8 = /*#__PURE__*/React.createElement("rect", {
  x: 35,
  y: 47,
  width: 284,
  height: 264,
  fill: "#CCCCCC"
});

var _ref9 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask1_131_90)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 265.593,
  y: 139,
  width: 48,
  height: 73,
  transform: "rotate(8.34372 265.593 139)",
  fill: "#EFEFEF"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 100.5,
  cy: 111.5,
  r: 55.5,
  fill: "#F8F8F8"
}), /*#__PURE__*/React.createElement("circle", {
  opacity: 0.4,
  cx: 169,
  cy: 278,
  r: 18,
  fill: "white"
}), /*#__PURE__*/React.createElement("circle", {
  opacity: 0.4,
  cx: 177.5,
  cy: 190.5,
  r: 11.5,
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.8,
  d: "M-40.1001 130.152L136.816 245.706L-51.7154 341.142L-40.1001 130.152Z",
  fill: "#F8F8F8"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.7,
  d: "M245.006 -58.452L398.159 87.1376L195.498 146.977L245.006 -58.452Z",
  fill: "#F8F8F8"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.9,
  d: "M210.164 204.8L331.478 292.298L195.047 353.61L210.164 204.8Z",
  fill: "#F8F8F8"
}));

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M279.082 290.894C279.082 288.919 278.241 280.05 281.936 280.35C284.439 280.553 284.874 286.924 285.068 288.476C285.52 292.094 285.587 296.323 284.433 299.852C281.756 308.04 286.649 282.728 288.714 274.365C290.413 267.486 290.278 288.487 290.141 295.571C290.101 297.648 289.785 291.426 289.785 289.348C289.785 288.624 289.418 285.325 290.855 287.049C291.207 287.471 292.547 290.216 292.995 288.793C293.196 288.155 293.239 282.649 293.709 282.649C294.767 282.649 295.32 291.199 295.492 284.988C295.535 283.471 300.92 284.213 302.271 283.402",
  stroke: "#333333",
  strokeWidth: 1.82472,
  strokeLinecap: "round"
});

var _ref11 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_d_131_90",
  x: 410.068,
  y: 186.068,
  width: 148.864,
  height: 272.718,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 4.46591
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_131_90"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_131_90",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter1_d_131_90",
  x: 0,
  y: 16,
  width: 354,
  height: 334,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 4
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 5
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_131_90"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_131_90",
  result: "shape"
})));

function SvgFeature1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 559,
    height: 459,
    viewBox: "0 0 559 459",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_131_90",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 346,
    y: 237,
    width: 70,
    height: 100
  }, _ref4), _ref5, _ref6, _ref7, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_131_90",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 35,
    y: 47,
    width: 284,
    height: 264
  }, _ref8), _ref9, _ref10, _ref11);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeature1);
export default __webpack_public_path__ + "static/media/feature1.903cd4fe.svg";
export { ForwardRef as ReactComponent };